@if (assistants.availableAssistantDisplaysSg().length === 0) {
  <div class="atn-assistant__empty-state">
    <i class="atn-icon atn-robot atn-assistant__empty-state-icon"></i>
    <p class="atn-assistant__empty-state-message">
      No assistants are available for your current context.
    </p>
  </div>
} @else {
  <atn-assistant-conversational [fullScreen]="fullScreenSg()" />
}
